export const mockReviewSummarizationResponse = {
  productId: '123456701',
  summary:
    'These shoes are extremely comfortable and well-made. The majority of reviewers praise the support, cushioning, and overall fit. A few customers have reported some minor issues with the durability, but most are highly satisfied with their purchase.',
  aspects: [
    {
      name: 'Comfort',
      summary: 'Reviewers consistently praise the exceptional comfort of these shoes, with many commenting on the excellent cushioning and support.',
      reviewCount: 3585,
      positivePercentage: 92,
      positiveReviewCount: 3215,
      negativePercentage: 2,
      negativeReviewCount: 70,
      neutralPercentage: 6,
      neutralReviewCount: 210,
      sentiment: 'positive'
    },
    {
      name: 'Fit',
      summary:
        'The majority of customers report that the shoes fit true to size and provide a comfortable, secure fit. A small percentage have experienced sizing issues.',
      reviewCount: 3500,
      positivePercentage: 87,
      positiveReviewCount: 2950,
      negativePercentage: 5,
      negativeReviewCount: 170,
      neutralPercentage: 8,
      neutralReviewCount: 270,
      sentiment: 'negative'
    },
    {
      name: 'Durability',
      summary: 'Most customers are satisfied with the durability of the shoes, though a few have reported premature wear or issues with the soles.',
      reviewCount: 2900,
      positivePercentage: 80,
      positiveReviewCount: 2400,
      negativePercentage: 12,
      negativeReviewCount: 360,
      neutralPercentage: 8,
      neutralReviewCount: 240,
      sentiment: 'positive'
    },
    {
      name: 'Style',
      summary: 'Reviewers generally appreciate the sleek, modern design of the shoes, which are available in a variety of stylish color options.',
      reviewCount: 3000,
      positivePercentage: 88,
      positiveReviewCount: 2730,
      negativePercentage: 4,
      negativeReviewCount: 120,
      neutralPercentage: 8,
      neutralReviewCount: 250,
      sentiment: 'neutral'
    }
  ]
};
